import { Injectable } from '@angular/core';
import { ApiResponse } from '@contracts';
import { ApiCilent } from '@core';
import { Observable, map } from 'rxjs';

import {
  ElectricityBillingSetting,
  OccupancyTableRow,
  ResidenceProfile,
} from '../types/setting.model';

import {
  ElectricityBillingSettingResponseDto,
  ResidenceProfileResponseDto,
  UpdateElectricityBillingReq,
  UpdateOccupancyReq,
  UpdateResidenceProfileReq,
} from '../types/setting.dto';

import { buildBillingData, buildProfileData } from '../types/setting.helper';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  constructor(private apiClient: ApiCilent) {}

  getResidenceProfile(): Observable<ResidenceProfile> {
    return this.apiClient
      .get<ApiResponse<ResidenceProfileResponseDto>>({
        path: 'landlord_info/',
        domain: 'core',
      })
      .pipe(
        map((res) => res.meta.response_data),
        map(buildProfileData),
      );
  }

  getElectricityBilling(): Observable<ElectricityBillingSetting> {
    return this.apiClient
      .get<ApiResponse<ElectricityBillingSettingResponseDto>>({
        path: 'landlord_billing/',
        domain: 'core',
      })
      .pipe(
        map((res) => res.meta.response_data),
        map(buildBillingData),
      );
  }

  getOccupancyTable(): Observable<OccupancyTableRow[]> {
    return this.apiClient
      .get<ApiResponse<OccupancyTableRow[]>>({
        path: 'landlord/building_tenant/',
        domain: 'core',
      })
      .pipe(map((res) => res.meta.response_data));
  }

  updateResidenceProfile(body: UpdateResidenceProfileReq): Observable<void> {
    return this.apiClient.put({
      path: 'landlord_info/',
      domain: 'core',
      body,
    });
  }

  updateElectricityBilling(
    body: UpdateElectricityBillingReq,
  ): Observable<void> {
    return this.apiClient.put({
      path: 'landlord_billing/',
      domain: 'core',
      body,
    });
  }

  updateOccupancyTable(body: UpdateOccupancyReq): Observable<void> {
    return this.apiClient.post({
      path: 'landlord/building_tenant/',
      domain: 'core',
      body,
    });
  }
}
